export default __webpack_public_path__ + "static/media/logo-blue.053f9872.svg";